import getInternalLinkURLWithoutDuplicatedForwardSlash from './getInternalLinkURLWithoutDuplicatedForwardSlash';

interface Props {
  /** example: `["first-level-url-slug", "second-level-url-slug"]` */
  urlChunks: string[];
  /** Optionally append trailing slash to the end of URL */
  hasTrailingSlash?: boolean;
}

const composeInternalLinkURL = ({
  urlChunks,
  hasTrailingSlash = true,
}: Props): InternalLinkURL | null => {
  if (!Array.isArray(urlChunks) || !urlChunks?.length) {
    return null;
  }

  const validURLChunks = urlChunks.filter(Boolean);

  if (!validURLChunks.length) {
    return null;
  }

  const mergedURLChunks = validURLChunks.join('/');

  const optionalTrailingSlash = hasTrailingSlash ? '/' : '';

  return getInternalLinkURLWithoutDuplicatedForwardSlash(
    `/${mergedURLChunks}${optionalTrailingSlash}`
  );
};

export default composeInternalLinkURL;
